import isString from 'lodash/isString';

import { FieldErrorLike } from '../types/FieldErrorLike';

/**
 * The text a field should show for its `error` prop: the string itself, or the
 * `message` off an error object. `true` marks a field invalid without a
 * message, so it yields ''.
 */
export const toErrorMessage = (
  error: boolean | string | FieldErrorLike | undefined,
): string => {
  if (isString(error)) {
    return error;
  }

  if (error && typeof error === 'object' && isString(error.message)) {
    return error.message;
  }

  return '';
};
